import { isGemXDevMode } from '~/server/auth/shopify/helpers';
import { useAppBridge } from '@shopify/app-bridge-react';
import { toast as notify } from 'sonner';
import { isBrowser } from '~/utils';

export interface IOptionToast {
  duration?: number;
  isError?: boolean;
  action?: string;
  onAction?: () => void;
  onDismiss?: () => void;
}

export function useToast() {
  if (!isBrowser() || isGemXDevMode()) {
    return {
      shopifyToast: (message: string, option?: IOptionToast) => {
        if (option?.isError) {
          notify.error(message);
        } else {
          notify.success(message, {
            action: option?.action && {
              label: option?.action,
              onClick: () => option?.onAction?.(),
            },
          });
        }
      }, // eslint-disable-line @typescript-eslint/no-unused-vars
    };
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { toast } = useAppBridge();

  const show = (message: string, option?: IOptionToast) => {
    toast.show(message, option);
  };
  return {
    shopifyToast: show,
  };
}
